import { Col, Form, Row, TreeSelect } from 'antd';
import { FormField } from 'components';
import get from 'lodash/get';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import {
  formFieldsActivityArea
} from './formFields';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { isBeneficiary} from 'utils';

const ActivityArea = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const activeTaskName = useSelector(state => state?.forms?.activeTaskName);
  const [form] = useForm();
  const carrier = useSelector(state => state.forms.carrier);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                    !isBeneficiary(user.groups) || 
                    applicationReturned ||
                    activeTaskName === "task.name.temporary_rejected" ||
                    activeTaskName === "task.name.application_returned_to_supplier" ||
                    activeTaskName === "task.name.accepted";

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'select' || type === 'number') {
      newValue = event;
    }
    if (newValue === ' ' && key==='marketing') {
      newValue = ''
    }
    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  useEffect(() => {
    form.setFieldsValue({
      marketing: carrier.marketing,
    });
  }, [form, carrier]);



  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  return (
    <>
    <Form
      form={form}
      initialValues={{
        ...carrier,
      }}
      trigger="onChange"
    >
    <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mt-4 carrier-data-form"
    >
      <Col span={24}>
          <p className="mt-0 mr-0 font-size-16 text-bold">
            Σχετικά με τον Προμηθευτή 
            <span className="color-red"> *</span>
          </p>
          {formFieldsActivityArea.map((field, index) => {
          return (
            <Col key={index} style={{paddingLeft:'0', width:'100%'}} span={field.span}>
              <Form.Item
                name={[field.name]}
                rules={field.rules}
                value={renderFieldValue(field)}
                validateFirst
              >
                <FormField
                  key={index}
                  //value={[carrier[field.name]]}
                  disabled={viewMode || applicationReturned || activeTaskName === "task.name.temporary_rejected"}
                  {...omit(field, ['span'])}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          )})}
        </Col>
      </Row>
    </Form>
  </>
  );
};

export default ActivityArea;
